/*
 SUMMARY:
 This module binds the events to the DOM elements, either mobile or desktop;
 for opening up the get pre approved modal
*/
(function getPreApprovedLoader(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const configurationElement = global.document.querySelector('[data-component="getPreApprovedIframeInformation"]');
  const previousGetPreApprovedLoader = global.NewHomeSource.GetPreApprovedLoader;

  if (!configurationElement) {
    return;
  }

  const iframeConfiguration = JSON.parse(configurationElement.innerHTML);

  /**
  * @private
  * bindGetPreApprovedFunction: binds the get pre approved elements with the respective JS handler.
  */
  function bindGetPreApprovedFunction() {
    const getPreApprovedElement = document.querySelector('[data-get-pre-approved-link]');
    if (!getPreApprovedElement) {
      return;
    }

    const onClickFunction = function () {
      const alreadyLoadedScript = document.getElementById('getPreApprovedModalPresenter');
      iframeConfiguration.CloseElement = global.document
        .querySelector('[data-component="close-button"]').content.cloneNode(true);

      if (global.define) {
        global.require([iframeConfiguration.JavascriptHandler], function () {
          window.NewHomeSource.IframePresenter.showModal(iframeConfiguration);
        });
      } else {

        if (alreadyLoadedScript) {
          window.NewHomeSource.IframePresenter.showModal(iframeConfiguration);
          return;
        }

        if (!iframeConfiguration.JavascriptHandler) {
          return;
        }

        NHS.loadJs(iframeConfiguration.JavascriptHandler, 'getPreApprovedModalPresenter', function () {
          window.NewHomeSource.IframePresenter.showModal(iframeConfiguration);
        });

        delete iframeConfiguration['JavascriptHandler'];
      }
    }

    getPreApprovedElement.addEventListener('click', onClickFunction);
  };

  /**
   * @constructs NewHomeSource.GetPreApprovedLoader
   */
  function GetPreApprovedLoader() {
    bindGetPreApprovedFunction();
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.GetPreApprovedLoader to the previous script.
   */
  GetPreApprovedLoader.noConflict = function noConflict() {
    global.NewHomeSource.GetPreApprovedLoader = previousGetPreApprovedLoader;
    return GetPreApprovedLoader;
  };

  global.NewHomeSource.GetPreApprovedLoader = GetPreApprovedLoader;
  GetPreApprovedLoader();
}(window));
